import RichtextModel from './richtext';
import Link from './link';
import Background from './background';
import AlertMessage from './alert-message';
import Image from './image';
import Media from './media';

export class Hero {
  title?: string;
  titleLine2?: string;
  color?: string;
  richTextAlignLeft: string;
  links?: Link[];
  description?: RichtextModel;
  heroImage?: Image;
  background?: Background;
  breadErrorMessage?: AlertMessage;
  svgImage?: Media;
  bikePrice?: number;

  constructor(props: any) {
    const {
      title,
      titleLine2,
      textColor,
      richTextAlignLeft,
      linksCollection,
      background,
      heroImage,
      description,
      breadError,
      svgImage,
      bikePrice
    } = props;
    this.title = title;
    this.titleLine2 = titleLine2;
    this.color = textColor;
    this.richTextAlignLeft = richTextAlignLeft;
    this.links = linksCollection?.items?.map((link: any) => new Link(link));
    this.background = new Background(background);
    this.heroImage = heroImage ? new Image(heroImage) : undefined;
    this.description = description ? new RichtextModel(description) : undefined;
    this.breadErrorMessage = breadError
      ? new AlertMessage(breadError)
      : undefined;
    this.svgImage = svgImage ? new Media(svgImage) : undefined;
    this.bikePrice = bikePrice;
  }
}

export default Hero;
